<template>
    <vs-collapse class="collapse">
      <vx-card>
        <vs-collapse-item>
          <h3 slot="header">
            Asset meta
          </h3>
          <table class="meta-table mt-3">
            <thead>
            <th>Key</th>
            <th>Value</th>
            </thead>
            <tbody>
            <tr v-for="(item, index) in asset.meta" :key="index">
              <td>
                <div>
                  <div class="table-input">
                    {{index}}
                  </div>
                </div>
              </td>
              <td>
                <div>
                  <div class="table-input">
                    {{item}}
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </vs-collapse-item>
      </vx-card>
    </vs-collapse>
</template>

<script>

export default {
  components: {

  },
  props: {
    asset: {type: Object}
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {

  },
}
</script>
